import { createSlice } from '@reduxjs/toolkit';

export const headerSlice = createSlice({
  name: 'header',
  initialState: {
    pageTitle: 'My Websites', // current page title state management
    breadcrumbs: [], // breadcrumb trail
    noOfNotifications: 15, // no of unread notifications
    newNotificationMessage: '', // message of notification to be shown
    newNotificationStatus: 1, // to check the notification type -  success/ error/ info
  },
  reducers: {
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload.title;
    },

    setBreadcrumbs: (state, action) => {
      const breadcrumbs = action.payload.breadcrumbs;
      state.breadcrumbs = breadcrumbs;

      // Auto-set page title from the last breadcrumb
      if (breadcrumbs.length > 0) {
        const lastCrumb = breadcrumbs[breadcrumbs.length - 1];
        state.pageTitle = lastCrumb.label;
      }
    },

    removeNotificationMessage: (state) => {
      state.newNotificationMessage = '';
    },

    showNotification: (state, action) => {
      state.newNotificationMessage = action.payload.message;
      state.newNotificationStatus = action.payload.status;
    },
  },
});

export const { setPageTitle, setBreadcrumbs, removeNotificationMessage, showNotification } = headerSlice.actions;

export default headerSlice.reducer;
